import React from "react";
import { Leaf } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const benefits = ["Early Access to New Releases", "Member-Only Vineyard Events", "Exclusive access to limited editions", "Curated wine collections", "Complimentary Wine Tastings"];
export default function JoinTheCellarClub() {
  return <section id="join-the-cellar-club" className="dark bg-background text-foreground">
      {}
      <div className="w-full bg-primary py-24 md:py-32 px-4 sm:px-6 lg:px-8">
        
        {}
        <div className="max-w-3xl mx-auto bg-card text-card-foreground border-[6px] border-double border-secondary/40 p-8 md:p-16 shadow-2xl relative">
          
          {}
          <div className="absolute top-3 left-3 size-4 border-t-2 border-l-2 border-secondary/60 opacity-70" />
          <div className="absolute top-3 right-3 size-4 border-t-2 border-r-2 border-secondary/60 opacity-70" />
          <div className="absolute bottom-3 left-3 size-4 border-b-2 border-l-2 border-secondary/60 opacity-70" />
          <div className="absolute bottom-3 right-3 size-4 border-b-2 border-r-2 border-secondary/60 opacity-70" />

          <div className="text-center mb-12 relative z-10">
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-card-foreground mb-6">
              Membership has its Vintages
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl max-w-xl mx-auto font-sans font-light">
              Join the VineEssence Cellar Club and uncork a world of exclusive benefits, curated specifically for the true wine enthusiast.
            </p>
          </div>

          <ul className="space-y-5 mb-14 max-w-md mx-auto relative z-10">
            {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-center gap-4 group">
                <Leaf className="size-6 text-secondary shrink-0 transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-12" />
                <span className="text-lg md:text-xl text-card-foreground/90 font-serif tracking-wide">{benefit}</span>
              </li>)}
          </ul>

          <div className="flex justify-center relative z-10">
            <Button variant="secondary" size="lg" className="text-lg px-12 py-7 font-semibold tracking-wider shadow-lg hover:shadow-xl transition-all hover:-translate-y-1" asChild>
              <Link to="/CellarClubPage">Join the Club</Link>
            </Button>
          </div>
          
        </div>
      </div>
    </section>;
}